import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    materialsStatus: '' // 材料审核的状态
  },
  getters: {
    getMaterialsStatus (state) {
      return state.materialsStatus
    }
  },
  mutations: {
    changeMaterialsStatus (state, status) {
      state.materialsStatus = status
    }
  },
  actions: {
    commitMaterialsStatus ({ commit }, status) {
      commit('changeMaterialsStatus', status)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js